import {MobileDrawerIcon} from "../../styles/Icons";
import {IconButton, useTheme} from "@mui/material";

const MobileDrawerButton = ({
  open,
  onClick
}: {
  open?: boolean
  onClick?: () => void
}) => {
  const theme = useTheme()
  const styles = {
    button: {
      bgcolor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      padding: "3px",
      mx: "4px",
    }
  }


  return (
    <IconButton onClick={onClick} sx={styles.button}>
      <MobileDrawerIcon open={open}/>
    </IconButton>
  )
}

export default MobileDrawerButton